/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiCornerOutUpRightIcon16Light = forwardRef('ArrowUiCornerOutUpRightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M4 2a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V8.5a.5.5 0 0 1 1 0V11a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h2.5a.5.5 0 0 1 0 1H4Z" }),
        React.createElement("path", { d: "M13 2.707 7.854 7.854a.5.5 0 1 1-.708-.708L12.293 2H9.5a.5.5 0 0 1 0-1h3A1.5 1.5 0 0 1 14 2.5v3a.5.5 0 0 1-1 0V2.707Z" })));
});
